<p-table *ngIf="showTable" [value]="tableData" scrollable="true" [rows]="12" scrollHeight="100%" [paginator]="false" styleClass="p-datatable-striped">
    <ng-template pTemplate="header">
        <tr>
            <th [pSortableColumn]="'currency'">
                Currency
                <p-sortIcon [field]="'currency'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'outAmount'">
                Outflow
                <p-sortIcon [field]="'outAmount'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'inAmount'">
                Inflow
                <p-sortIcon [field]="'inAmount'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'baseOutAmount'">
                {{'Inflow (' + currency + ')'}}
                <p-sortIcon [field]="'baseOutAmount'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'baseInAmount'">
                {{'Outflow (' + currency + ')'}}
                <p-sortIcon [field]="'baseInAmount'"></p-sortIcon>
            </th>
            <th>FX Rate</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
        <tr>
            <td style="text-align: center;">{{row.currency}}</td>
            <td style="text-align: center;">
                {{row.outAmount | currencyrounding:2:currency:'symbol-narrow' }}
            </td>
            <td style="text-align: center;">
                {{row.inAmount | currencyrounding:2:currency:'symbol-narrow' }}
            </td>
            <td style="text-align: center;">
                {{row.baseOutAmount | currencyrounding:2:currency:'symbol-narrow' }}
            </td>
            <td style="text-align: center;">
                {{row.baseInAmount | currencyrounding:2:currency:'symbol-narrow' }}
            </td>
            <td style="text-align: center;">
                {{row.fxRate | number : '1.4-4'}}
            </td>
        </tr>
    </ng-template>



    <!-- <p-column [styleClass]="'col-currency'" field="currency" header="Currency" [sortable]="true"></p-column>
    <p-column [styleClass]="'col-out-amount'" field="outAmount" header="Outflow" [sortable]="true">
        <ng-template let-row="rowData" pTemplate="body">
            {{row.outAmount | currencyrounding:2:currency:'symbol-narrow' }}
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-in-amount'" field="inAmount" header="Inflow" [sortable]="true">
        <ng-template let-row="rowData" pTemplate="body">
            {{row.inAmount | currencyrounding:2:currency:'symbol-narrow' }}
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-base-out-amount'" field="baseOutAmount" [header]="'Inflow (' + currency + ')'" [sortable]="true">
        <ng-template let-row="rowData" pTemplate="body">
            {{row.baseOutAmount | currencyrounding:2:currency:'symbol-narrow' }}
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-base-amount'" field="baseInAmount" [header]="'Outflow (' + currency + ')'" [sortable]="true">
        <ng-template let-row="rowData" pTemplate="body">
            {{row.baseInAmount | currencyrounding:2:currency:'symbol-narrow' }}
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-fx-rate'" field="fxRate" header="FX Rate" [sortable]="false">
        <ng-template let-row="rowData" pTemplate="body">
            {{row.fxRate | number : '1.4-4'}}
        </ng-template>
    </p-column> -->
<!--Already commented-->
    <!-- <ng-template pTemplate="colgroupfooter" let-car>
        <td colspan="1" style="text-align:right">Totals</td>
        <td>{{totalOutAmount | currencyrounding:2:currency:'symbol-narrow' }}</td>
        <td>{{totalInAmount | currencyrounding:2:currency:'symbol-narrow' }}</td>
        <td>{{totalBaseOutAmount | currencyrounding:2:currency:'symbol-narrow' }}</td>
        <td>{{totalBaseInAmount | currencyrounding:2:currency:'symbol-narrow' }}</td>
        <td></td>
    </ng-template> -->


    <ng-template pTemplate="footer">
        <tr>
            <td [ngStyle]="{'text-align':'right','font-weight':'bold'}">Totals:</td>
            <td [ngStyle]="{'text-align':'center','font-weight':'bold'}">{{totalOutAmount}}</td>
            <td [ngStyle]="{'text-align':'center','font-weight':'bold'}">{{totalInAmount}}</td>
            <td [ngStyle]="{'text-align':'center','font-weight':'bold'}">{{totalBaseOutAmount | currencyrounding:2:currency:'symbol-narrow'}}</td>
            <td [ngStyle]="{'text-align':'center','font-weight':'bold'}">{{totalBaseInAmount | currencyrounding:2:currency:'symbol-narrow'}}</td>
            <td></td>
        </tr>
    </ng-template>

    <!-- <p-footerColumnGroup>
        <p-row>
            <p-column footer="Totals:" colspan="1" [style]="{'text-align':'right','font-weight':'bold'}"></p-column>
            <p-column [footer]="totalOutAmount" [style]="{'text-align':'center','font-weight':'bold'}"></p-column>
            <p-column [footer]="totalInAmount" [style]="{'text-align':'center','font-weight':'bold'}"></p-column>
            <p-column [footer]="totalBaseOutAmount | currencyrounding:2:currency:'symbol-narrow' " [style]="{'text-align':'center','font-weight':'bold'}"></p-column>
            <p-column [footer]="totalBaseInAmount | currencyrounding:2:currency:'symbol-narrow' " [style]="{'text-align':'center','font-weight':'bold'}"></p-column>
            <p-column></p-column>
        </p-row>
    </p-footerColumnGroup> -->
</p-table>